<template>
  <div class="card" v-bind="$attrs">
    <div class="card-header d-flex justify-content-between">
      <h5 class="text-uppercase mb-0">Activités</h5>
      <button class="btn btn-link link-dark p-0 link-underline-opacity-0 link-underline-opacity-100-hover" @click="addActivity()"><i class="fa-solid fa-plus pe-1"></i>Ajouter une activité</button>
    </div>
    <div class="card-body">
      <div v-if="activities.length === 0" class="text-muted">
        Aucune activité
      </div>
      <div v-else v-for="(activity, idx) in activities" :key="activity.key" class="mb-2 card card-body">
        <span :id="`${props.valueKey}[${idx}]`" class="anchor"></span>
        <div class="row mb-3">
          <div class="col-12 col-lg-6 col-xl-8">
            <TextInputComponent
              :value-key="`${props.valueKey}[${idx}].name`"
              label="Nom"
              placeholder="Nom"
              :required="true"
              class="mb-3 mb-md-0"
            />
          </div>
          <div class="col-12 col-lg-4 col-xl-2">
            <NumberInputComponent v-show="!activity.value.noPrice"
              :value-key="`${props.valueKey}[${idx}].price`"
              label="Prix"
              placeholder="Prix"
              :required="true"
              type="euro"
              group-text="/ pers"
              :disabled="activities[idx].value.noPrice"
            />
          </div>
          <div class="col-12 col-lg-2 d-flex align-items-center justify-content-between">
            <CheckboxComponent
              :value-key="`${props.valueKey}[${idx}].noPrice`"
              label="Pas de prix"
              :required="true"
              class="pe-2"
            />
            <i role="button" class="fa-regular fa-trash-can" @click="removeOption(idx)"></i>
          </div>
        </div>
        <div class="row">
          <div class="col">
              <TextInputComponent
                :value-key="`${props.valueKey}[${idx}].description`"
                label="Description"
                placeholder="Description"
                :required="false"
                type="multiline"
                :rows="2"
              />
          </div>
        </div>

        <div class="row">
          <div class="col">
              <FileUploadComponent
                type="image"
                :value-key="`${props.valueKey}[${idx}].picture`"
                label="Image"
                placeholder="Image"
                :required="false"
                height="80px"
                :hide-icon="true"
                class="my-3"
              />
          </div>
        </div>

        <div class="row">
          <div class="col">
              <TextInputComponent
                :value-key="`${props.valueKey}[${idx}].details`"
                label="InfoBulle"
                placeholder="InfoBulle"
                :required="false"
                type="multiline"
                :rows="2"
              />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import { useFieldArray } from 'vee-validate';
import {IdNotDefined } from '@/compositions/helper'
import TextInputComponent from '@/components/common/TextInputComponent.vue';

import * as zod from 'zod';

const props = defineProps<{
  valueKey: AllTypeKeys;
}>();

const validationSchema = defineModel<{ shape: zod.ZodRawShape, anchors?: Record<string, string  | undefined> }>('validation-schema',{ required: false, default: () => ({ shape: {} }) });

const { remove: removeOption, push: pushActivity, fields: activities } = useFieldArray<TravelDbOptionActivity>(() => props.valueKey);

const addActivity = () => {
  pushActivity(<TravelDbOptionActivity>{
    id: IdNotDefined,
    name: '',
    price: 0,
    quota: 0,
    noPrice: false
  });
}

onMounted(() => {
  validationSchema.value = {
    shape: {
      activities: zod.array(zod.object({
        id: zod.number().nonnegative(),
        name: zod.string().min(1, 'Le nom de l\'activité est obligatoire'),
        price: zod.number({ message:'Le prix de l\'activité est obligatoire'}).min(0, 'Le prix de l\'activité doit être au minimum 0'),
        noPrice: zod.boolean(),
        description: zod.string().optional(),
        details: zod.string().optional(),
        picture: zod.object({
          id: zod.number().nonnegative(),
          key: zod.string().uuid().optional(),
          mimeType: zod.string().optional(),
          base64Content: zod.string().optional()
         }).optional(),
      })).optional()
  },
  anchors: {
    [`${props.valueKey}[\\d].id`]: "self",
    [`${props.valueKey}[\\d].name`]: "self",
    [`${props.valueKey}[\\d].price`]: "self",
    [`${props.valueKey}[\\d].noPrice`]: "self",
    [`${props.valueKey}[\\d].description`]: "self",
    [`${props.valueKey}[\\d].details`]: "self",
    [`${props.valueKey}[\\d].picture`]: "self",
  }
}
});
</script>
